<template>
  <nav class="snavTree">
    <h2 class="snavTreeHead">商品カテゴリー</h2>
    <div class="snavTreeList-loading" v-if="loading">Loading...</div>
    <template v-else>
      <ul class="snavTreeList" v-if="cats.length">
        <li
          v-if="$route.path ==='/home/'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Home', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
        <li
          v-if="$route.path === '/business/'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Business', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
        <li
          v-if="$route.path === '/gift/'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Gift', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
        <li
          v-if="$route.name === 'Home'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Home', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
        <li
          v-if="$route.name === 'Business'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Business', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
        <li
          v-if="$route.name === 'Gift'"
          class="snavTreeList_item"
          v-for="cat of cats"
          :key="cat.id">
          <router-link :to="{name: 'Gift', params: { slug: cat.slug, id: cat.id }}">
            {{cat.name}}
          </router-link>
       </li>
      </ul>
    </template>
  </nav>
</template>

<script>
import axios from 'axios'
import 'promise-polyfill/src/polyfill'
export default {
  name: 'Route_Parent',
  data () {
    return {
      cats: [],
      products: [],
      termId: null,
      childId: null,
      loading: false
    }
  },
  created () {
    this.loading = true
    if (Object.keys(this.$route.params).length !== 0) {
      switch (this.$route.name) {
        case 'Home':
          this.termId = 15
          break
        case 'Business':
          this.termId = 16
          break
        case 'Gift':
          this.termId = 17
          break
      }
      axios
        .get(`/wp-json/wp/v2/product_category?parent=` + this.termId + `&per_page=100&orderby=menu_order&order=asc`)
        .then(response => {
          this.loading = false
          this.cats = response.data
        })
    } else {
      switch (this.$route.path) {
        case '/home/':
          this.termId = 15
          break
        case '/business/':
          this.termId = 16
          break
        case '/gift/':
          this.termId = 17
          break
        default:
          this.termId = 15
          break
      }
      axios
        .get(`/wp-json/wp/v2/product_category?parent=` + this.termId + `&per_page=100&orderby=menu_order&order=asc`)
        .then(response => {
          this.loading = false
          this.cats = response.data
        })
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.id) {
        this.fetchData(to.params.id)
      } else {
        this.loading = true
        switch (to.path) {
          case '/home/':
            this.fetchData(15)
            break
          case '/business/':
            this.fetchData(16)
            break
          case '/gift/':
            this.fetchData(17)
            break
        }
      }
    }
  },
  methods: {
    fetchData (id) {
      axios
        .get(`/wp-json/wp/v2/products?product_category=` + id + `&per_page=100&orderby=menu_order&order=asc`)
        .then(response => {
          if (response.data.length) {
            this.termId = response.data[0].product_category[0]
          } else {
            switch (this.$route.name) {
              case 'Home':
                this.termId = 15
                break
              case 'Business':
                this.termId = 16
                break
              case 'Gift':
                this.termId = 17
                break
            }
          }
          axios
            .get(`/wp-json/wp/v2/product_category?parent=` + this.termId + `&per_page=100&orderby=menu_order&order=asc`)
            .then(response => {
              this.loading = false
              this.cats = response.data
            })
        })
    }
  }
}
</script>

<style>
  .snavTreeList-loading {
    border-top: solid 1px #f7f6f3;
    padding: 10px 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteParent.vue